<div class="flex flex-row gap-[30px]"  >
  <mat-checkbox
    class="form-field"
    [(ngModel)]="node.isAsync"
    color="primary"
    i18n
    [attr.data-testid]="'get-account-link-url-sync-mode-checkbox'"
  >
    {{ node.isAsync ? notText : '' }}同步模式
  </mat-checkbox>

  <mat-form-field class="flex-[1_0_0%]"  legacyAppearance>
    <mat-label i18n>回傳變數</mat-label>
    <input
      matInput
      [(ngModel)]="node.responseVar"
      [attr.data-testid]="'get-account-link-url-response-var-input'"
    />
  </mat-form-field>
</div>
